module.exports = __webpack_public_path__ + "img/SWP_Sword_1H_01.534988e3.png";